import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DashboardQuizB from "./component";
import {
  saveUserAnswer,
  getBulkQuestions,
  updateUserAnswer,
  updateAssessmentAttempt,
  createAssessmentAttempt,
  getOneQuestionPerAssessment,
} from "../../pages/quiz/actions";
import { getAssessment } from "../../pages/dashboard/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllAssessmentConnect: getAssessment,
      getBulkQuestionsConnect: getBulkQuestions,
      saveUserAnswerConnect: saveUserAnswer,
      updateUserAnswerConnect: updateUserAnswer,
      createAssessmentAttemptConnect: createAssessmentAttempt,
      updateAssessmentAttemptConnect: updateAssessmentAttempt,
      getOneQuestionPerAssessmentConnect: getOneQuestionPerAssessment,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DashboardQuizB);
